import { render, staticRenderFns } from "./IconScissorsSolid.vue?vue&type=template&id=abff4fc8"
import script from "./IconScissorsSolid.vue?vue&type=script&lang=js"
export * from "./IconScissorsSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports